import * as yup from "yup";

export const agentContactForm = yup.object().shape({
  email: yup
    .string()
    .email("Please enter a valid email.")
    .required("Please enter your email."),
  name: yup.string().required("Please enter your name."),
  message: yup.string().required("Please enter your message."),
  phoneNumber: yup.string().required("Please enter your phone number.")
});
